export interface Feature {
  name: string;
  description: string;
  Icon: (props: React.ComponentProps<"svg">) => JSX.Element;
  comingSoon?: true;
  citationNeeded?: boolean;
}

interface FeatureGridProps {
  header: string;
  features: Feature[];
}

export const FeatureGrid = ({ header, features }: FeatureGridProps) => {
  return (
    <div className=" bg-gray-200 px-24  pt-[72px] pb-60 dark:bg-black dark:text-white   lg:px-28  xl:px-60">
      <div className="container-lg">
        <h3 className="font-display text-32-36 font-bold">
          <div className="">{header}</div>
        </h3>
        <div className="grid-12 mt-52">
          <dl className="col-span-full grid gap-32 sm:col-span-12 sm:col-start-1 sm:gap-40 md:grid-cols-3 md:gap-80 md:px-0">
            {features.map((feature) => (
              <div
                key={feature.name}
                className="flex items-start gap-24 md:flex-col"
              >
                <div>
                  <feature.Icon className="mb-16 h-24 w-24 text-blue-600 dark:text-blue-100" />
                  <dt className="flex flex-wrap items-center gap-x-8 gap-y-4">
                    <p className="text-18-24 font-bold text-gray-900 dark:text-gray-100">
                      {feature.name}
                    </p>
                    {feature.comingSoon && (
                      <div className="h-min rounded bg-yellow-200 px-4 py-2 text-11-14">
                        <span className="whitespace-nowrap text-11-14 font-bold text-yellow-800">
                          Coming soon
                        </span>
                      </div>
                    )}
                  </dt>
                  <dd className="mt-8 text-16-24 text-gray-700 dark:text-blue-200 ">
                    {feature.description}
                    {feature.citationNeeded && (
                      <div className="mx-8 inline-block h-min rounded bg-yellow-200 px-4 py-2 pb-2 text-11-14">
                        <span className="whitespace-nowrap text-11-14 font-bold text-yellow-800">
                          citation needed
                        </span>
                      </div>
                    )}
                  </dd>
                </div>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
};
